






import { Component, Prop, Vue } from 'vue-property-decorator';
import { linkedIn, linkedInLiteral } from '@/data';

@Component
export default class MoreOn extends Vue {
  @Prop(Boolean) public topRight!: boolean;

  public linkedIn: string = linkedIn;
  public linkedInLiteral: string = linkedInLiteral;

  get classes(): object {
    return {
      'moreOn': true,
      'moreOn--topRight': !!this.topRight,
    };
  }
}
